module.exports = "\r\n<p-dialog [visible]=\"true\"\r\n\t\t  [width]=\"200\"\r\n\t\t  appendTo=\"body\"\r\n\t\t  [modal]=\"true\"\r\n\t\t  [resizable]=\"false\"\r\n\t\t  [draggable]=\"false\"\r\n\t\t  [closeOnEscape]=\"false\"\r\n\t\t  [closable]=\"false\"\r\n          [showHeader]=\"false\"\r\n\t\t  [responsive]=\"false\">\r\n\t<p-progressSpinner [strokeWidth]=\"3\"\r\n\t\t\t\t\t   [animationDuration]=\"3\">\r\n\t</p-progressSpinner>\r\n\t<h3 class=\"text-center\">{{title}}</h3>\r\n</p-dialog>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/utility/loader/loader.component.html
// module id = ./src/app/components/utility/loader/loader.component.html
// module chunks = main